import React from 'react';
import { useAuth } from '../../context/AuthContext';
import { B } from '../../context/ThemeContext';

export function PermissionGate({ children, action, resource, fallback = null }) {
  const { hasPermission } = useAuth();
  
  if (hasPermission(action, resource)) {
    return children;
  }
  
  return fallback;
}

export function AccessDenied({ message = "You don't have permission to access this page." }) {
  return (
    <div style={{ textAlign: 'center', padding: '60px 20px', color: B.muted }}>
      <div style={{ fontSize: '3rem', marginBottom: 16 }}>🔒</div>
      <div style={{ fontSize: 'clamp(18px, 5vw, 24px)', fontWeight: 700, color: B.navy, marginBottom: 8 }}>Access Denied</div>
      <div style={{ fontSize: 13, maxWidth: 400, margin: '0 auto' }}>{message}</div>
      <div style={{ fontSize: 11, color: B.muted, marginTop: 16 }}>Please contact your administrator if you believe this is an error.</div>
    </div>
  );
}

export function RoleBadge({ role }) {
  const roleColors = {
    admin: { bg: '#dc2626', color: '#fff' },
    nurse_manager: { bg: '#f59e0b', color: '#fff' },
    nurse: { bg: '#3b82f6', color: '#fff' },
    caregiver: { bg: '#10b981', color: '#fff' },
    staff: { bg: '#6b7280', color: '#fff' },
  };
  
  const colors = roleColors[role] || roleColors.staff;
  
  return (
    <span style={{
      display: 'inline-block',
      padding: '2px 8px',
      borderRadius: 20,
      fontSize: 10,
      fontWeight: 700,
      background: colors.bg,
      color: colors.color,
      textTransform: 'capitalize'
    }}>
      {role?.replace('_', ' ')}
    </span>
  );
}